import { all } from 'redux-saga/effects';
import getConversation from './get_conversation';
import getHash from './get_hash';
export default function* intercomSaga() {
    yield all([getConversation, getHash]);
}
